import { useCallback, useState } from 'react';
import { MobileDrawer } from '../components/header/MobileDrawer';
import { SOCIALS, MENU_ITEMS } from '../components/header/headerLinks';
import { useGlobalComponentsContext } from 'src/contexts/GlobalComponentsContext';

const MOBILE_DRAWER_ID = 'MOBILE_DRAWER_ID' as const;

export const useMobileDrawer = () => {
  const { union, remove } = useGlobalComponentsContext();
  const [isOpen, setIsOpen] = useState(false);
  const MobileDrawerComponent = (
    <MobileDrawer
      socials={SOCIALS}
      menuItems={MENU_ITEMS}
      handleClose={() => {
        return remove(MOBILE_DRAWER_ID);
      }}
    />
  );
  const toggle = useCallback(() => {
    if (isOpen) {
      setIsOpen(false);
      return remove(MOBILE_DRAWER_ID);
    }
    setIsOpen(true);
    return union(MOBILE_DRAWER_ID, MobileDrawerComponent);
  }, [MobileDrawerComponent, isOpen, remove, union]);
  return { toggle, isOpen };
};
